import styled from 'styled-components'

export const StyledEmoji = styled.span`
  font-size: var(--fs-xxxl);
`
